/**
 * 잔류물질안전정보시스템 v3 - 애플리케이션 진입점
 *
 * Provider 스택 구성:
 *   Redux Provider → QueryClientProvider → BrowserRouter → ConfigProvider (antd 한국어 로케일)
 *
 * React 17 기반으로 ReactDOM.render를 사용한다 (createRoot 아님).
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import koKR from 'antd/lib/locale/ko_KR';

import store from './store';
import App from './App';

// 스타일 (순서 중요: antd → 변수 → 전역 → 디자인 토큰 → 인덱스)
import 'antd/dist/antd.css';
import './styles/variables.css';
import './styles/global.css';
import './styles/design-tokens.css';
import './index.css';

// ─── React Query 클라이언트 설정 ────────────────────────────

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,                        // 실패 시 1회 재시도
      refetchOnWindowFocus: false,     // 윈도우 포커스 시 자동 재조회 비활성화
      staleTime: 2 * 60 * 1000,       // 2분간 데이터 신선도 유지
    },
  },
});

// ─── 애플리케이션 렌더링 ────────────────────────────────────

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ConfigProvider locale={koKR}>
            <App />
          </ConfigProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
